module.exports = __webpack_public_path__ + "static/media/fundo.4662f090.png";